export default __webpack_public_path__ + "static/media/reflexGame.6e8b6a32.png";